/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import styled from 'styled-components'

// Libraries
import parse from 'html-react-parser'

// Elements
import ButtonDefault from 'components/elements/ButtonDefault'
import ParseContent from 'components/shared/ParseContent'
import RatingAlt from 'components/Reviews/RatingAlt'

//
import Input from './Input'

const ExpandButton = styled.div`
  font-size: ${(props) => props.theme.font.size.xm};
  font-weight: ${(props) => props.theme.font.weight.s};
`

const ButtonInfo = styled.div`
  color: ${(props) => props.theme.color.text.secondary};
`

const ButtonDefaultSubmit = styled.button`
  color: ${(props) => props.theme.color.text.light};

  &:hover {
    text-decoration: underline;
  }
`

const StyledRatingAlt = styled(RatingAlt)`
  .row {
    margin: 0 !important;
  }
`

const Step2 = ({
  fields,
  formFields,
  setExpanded,
  expanded,
  setData,
  data,
  setFieldValue,
  handleSubmit,
}) => {
  const explanation = formFields.filter(
    ({ inputName, visibility }) =>
      (inputName === 'explanation' || inputName === 'how_did_you_find_us') &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )
  const rest = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === '' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )

  return (
    <div>
      <div className="row">
        <div className="col-lg-6">
          {rest.map((edges) => (
            <Input
              key={edges.id}
              edges={edges}
              setData={setData}
              data={data}
              setFieldValue={setFieldValue}
            />
          ))}
        </div>
        <div className="col-lg-6 mt-4 mt-md-0">
          {explanation.map((edges) => (
            <Input
              key={edges.id}
              edges={edges}
              setData={setData}
              data={data}
              setFieldValue={setFieldValue}
            />
          ))}
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-6">
          {parseFloat(expanded) === 0 && (
            <ExpandButton
              role="button"
              onClick={() => {
                setExpanded(1)
              }}
            >
              {parse(fields.expand_description_out)}
            </ExpandButton>
          )}

          {parseFloat(expanded) === 1 && (
            <ExpandButton
              role="button"
              onClick={() => {
                setExpanded(0)
              }}
            >
              {parse(fields.expand_description_in)}
            </ExpandButton>
          )}
        </div>
        <div className="col-lg-6 d-flex align-items-center justify-content-end">
          <div className="text-right">
            <ButtonDefault type="next" isCustom>
              <ButtonDefaultSubmit
                type="submit"
                onClick={() => {
                  handleSubmit()
                }}
              >
                {fields.button_next}
              </ButtonDefaultSubmit>
            </ButtonDefault>
            <ButtonInfo className="mt-3 font-size-xm font-weight-s mb-4">
              <ParseContent content={fields.button_next_info} />
            </ButtonInfo>
            <StyledRatingAlt noTitle />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step2
